<tt-page *ngIf="!!setting">
    <tt-page-heading [ttModel]="'p2_m_dataminingtable'" ttTranslate></tt-page-heading>

    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-textarea ttLabel="filterinfo" [ttModel]="setting.filterinfo" ttReadonly></tt-textarea>
        <tt-input ttLabel="grouping_colname" [ttModel]="setting.grouping_colname" ttReadonly></tt-input>
        <tt-select ttRememberId="w_dataminingtable.column_colname" ttLabel="column_colname" [(ttModel)]="setting.column_colname" (ttModelChange)="onChanged($event, 'column_colname')" [ttData]="selectListColumnNames" ttDataId="column_colname" ttDataName="column_colname_translated"></tt-select>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
